import Carousel from "react-bootstrap/Carousel";
import PrincipalImg from "../assets/images/principal.png";
import DirectorImg from "../assets/images/dir.jpg";
import ChairmanImg from "../assets/images/chair2.JPG";

function SliderInfo() {
  return (
    <section>
      <Carousel
        className="text-dark"
        variant="dark"
        style={{ backgroundColor: "#6f6f6f26" }}
      >
        {/* className="bg-dark text-white" */}
        <Carousel.Item>
          <div className="row d-flex align-items-center justify-content-around">
            <div className="py-5 col-lg-4 slider-text">
              <h2 className="text-capitalize">Message from Chairperson</h2>
              {/* <div className="text-dark leading-relaxed">
                                <p className="font-bold">Dear Parents and Guardians,</p>
                                <p className="mt-2">
                                    Welcome to Kanchan Vidya Mandir — where we nurture each child’s potential with care and purpose. We believe education shapes both intellect and character.
                                </p>
                                <p className="mt-2">
                                    Our focus is on creating a learning environment rooted in values, curiosity, and discipline—preparing students to grow into confident, responsible individuals.
                                </p>
                                <p className="mt-2">
                                    Thank you for your trust and support in this shared journey.
                                </p>
                                <p className="mt-4 font-bold">
                                    Warm regards,<br />
                                    Sumitra Gupta<br />
                                    Chairperson
                                </p>
                            </div> */}
              <p>
                <b>Dear Parents,</b>
                <br />
                As the Chairperson of{" "}
                <b>Kanchan Vidya Mandir Sr. Sec. School</b>, it is my honor to
                extend a heartfelt welcome to our school community. Our
                institution is committed to delivering high-quality education
                that equips students with the knowledge and character necessary
                for lifelong success. We aim to foster a nurturing environment
                where learning and growth go hand in hand.
                <br />
                <br />
                We deeply value the partnership between the school, students,
                and families, recognizing it as a cornerstone of our
                accomplishments. Together, we aspire to build a brighter future
                for every child.
                <br />
                <br />
                <b>Warm regards,</b>
                <br />
                <b>Sumitra Gupta</b>
                <br />
                Chairperson
              </p>
            </div>
            <div className="col-lg-4 mt-5 mt-lg-0">
              {/* <img src={ChairmanImg} className='img-fluid' style={{borderRadius:10}} alt="" /> */}
              <img
                src={ChairmanImg}
                className="img-fluid"
                style={{
                  borderRadius: 10,
                  maxHeight: "400px",
                  objectFit: "cover",
                }}
                alt=""
              />
            </div>
          </div>
          <Carousel.Caption />
        </Carousel.Item>
        <Carousel.Item>
          <div className="row d-flex align-items-center justify-content-around">
            <div className="py-5 col-lg-4 slider-text">
              <h2 className="text-capitalize">Message from Principal</h2>
              {/* <div className="text-gray-800 leading-relaxed">
                                <p className="font-bold">Dear Students and Parents,</p>
                                <p className="mt-2">
                                    At Kanchan Vidya Mandir, education is a journey of growth and discovery. As Principal, I’m proud to lead a team dedicated to nurturing every child's unique potential.
                                </p>
                                <p className="mt-2">
                                    We strive for academic excellence while instilling values, discipline, and creativity—preparing students to meet modern challenges with confidence and compassion.
                                </p>
                                <p className="mt-2">
                                    With your continued support, we’re building a brighter, empowered future for all our students.
                                </p>
                                <p className="mt-4 font-bold">
                                    Sincerely,<br />
                                    [Your Principal’s Name]<br />
                                    Principal
                                </p>
                            </div> */}
              <p>
                <b>Dear Parents,</b>
                <br />
                As the Principal of <b>Kanchan Vidya Mandir Sr. Sec. School</b>,
                I am delighted to extend a warm welcome to you and your family.
                At our school, we prioritize a holistic education that nurtures
                both intellectual and personal growth. Our dedicated team
                gallery tirelessly to cultivate an atmosphere where students can
                thrive and reach their fullest potential.
                <br />
                <br />
                We understand the importance of collaboration between the
                school, students, and parents in achieving educational
                excellence. Your support is invaluable in helping us shape the
                future leaders of society.
                <br />
                <br />
                <b>Warm regards,</b>
                <br />
                <b>Pinki Kaushik</b>
                <br />
                Principal
              </p>
            </div>
            <div className="col-lg-4 mt-5 mt-lg-0">
              {/* <img src={PrincipalImg} className='img-fluid' style={{borderRadius:10}}alt="" /> */}
              <img
                src={PrincipalImg}
                className="img-fluid"
                style={{
                  borderRadius: 10,
                  maxHeight: "400px",
                  objectFit: "cover",
                }}
                alt=""
              />
            </div>
          </div>
          <Carousel.Caption />
        </Carousel.Item>
        <Carousel.Item>
          <div className="row d-flex align-items-center justify-content-around">
            <div className="py-5 col-lg-4 slider-text">
              <h2 className="text-capitalize">Message from Director</h2>
              <p>
                <b>Dear Parents,</b>
                <br />
                As the Director of <b>Kanchan Vidya Mandir Sr. Sec. School</b>,
                I am pleased to welcome you to our learning community. We are
                committed to providing meaningful education that builds strong
                values, clear thinking, and confidence in every student. With
                experienced teachers and supportive academic programs, we
                encourage each child to discover strengths and pursue goals with
                dedication.
                <br />
                <br />
                Your trust and cooperation with the school inspire us to keep
                improving and guiding students toward a successful, responsible
                future. Together we will build a path for every child.
                <br />
                <br />
                <b>Warm regards,</b>
                <br />
                <b>Naresh gupta</b>
                <br />
                Director
              </p>
            </div>
            <div className="col-lg-4 mt-5 mt-lg-0">
              <img
                src={DirectorImg}
                className="img-fluid"
                style={{
                  borderRadius: 10,
                  maxHeight: "400px",
                  objectFit: "cover",
                }}
                alt=""
              />
            </div>
          </div>
          <Carousel.Caption />
        </Carousel.Item>
      </Carousel>
    </section>
  );
}

export default SliderInfo;
